module.exports = __webpack_public_path__ + "05_long_gray.91eb7db6.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/daughter/layer5/05_long_gray.png
// module id = 9NyE
// module chunks = 0